import { Button, Stack, Typography } from '@locus-taxy/disco-ui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { List as FormatListBulleted } from 'lucide-react';

export interface TimelineEmptyStateProps {
  filterInfo?: unknown;
  resetFilters?: () => void;
}
export default function TimelineEmptyState({
  filterInfo,
  resetFilters,
}: Readonly<TimelineEmptyStateProps>) {
  const { t } = useTranslation();
  const hasFilters = Boolean(
    (filterInfo as { conditions?: unknown[] } | undefined)?.conditions?.length
  );
  return (
    <Stack direction="column" gap={3} align="center" className="text-center">
      <Stack direction="column" gap={1} align="center">
        <Typography variant="h1" color="muted" gutterBottom>
          <FormatListBulleted className="size-12" />
        </Typography>
        <Typography variant="body1" color="default" gutterBottom>
          {t('dashboard.timeline.noEvents', 'No timeline events available')}
        </Typography>
        {hasFilters && (
          <button
            type="button"
            onClick={resetFilters}
            className="cursor-pointer border-0 bg-transparent p-0 text-inherit"
          >
            <Typography variant="body2" component="span">
              {t(
                'dashboard.timeline.noEventsDescription',
                'There are no timeline events to display for this entity.'
              )}
            </Typography>
          </button>
        )}
      </Stack>
      {hasFilters && (
        <Button variant="outline" onClick={resetFilters}>
          {t('dashboard.timeline.reset', 'Reset Filters')}
        </Button>
      )}
    </Stack>
  );
}
